"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SingularComponentStore = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var stores = {};

var SingularComponentStore = /*#__PURE__*/function () {
  // a store is a singleton per key, but will delete itself when needed
  function SingularComponentStore(key) {
    _classCallCheck(this, SingularComponentStore);

    if (!stores[key]) {
      this.components = [];
      this.lastAnimation = {
        ongoing: false
      };
      this._key = key;
      stores[key] = this;
    }

    return stores[key];
  }

  _createClass(SingularComponentStore, [{
    key: "forceUpdateComponents",
    value: function forceUpdateComponents() {
      this.components.forEach(function (component) {
        return component.forceUpdate();
      });
    }
  }, {
    key: "register",
    value: function register(component) {
      this.cancelClearStore();
      this.components.forEach(function (component) {
        return component.setStoreSnapshot();
      });
      this.components.push(component);
      this.forceUpdateComponents();
    }
  }, {
    key: "unregister",
    value: function unregister(component) {
      var index = this.components.indexOf(component);

      if (index !== -1) {
        this.components.splice(index, 1);
        this.forceUpdateComponents();
      }

      if (this.components.length === 0) {
        if (this.lastAnimation.ongoing) this.lastAnimation.cancel(true);
        this.requestClearStore();
      }
    } // requestClearStore and cancelClearStore are using requestAnimationFrame
    // this is because if the the store emptied up and was not filled back in the same animationFrame
    // the component will flicker (because the store was empty in the animation frame which heppens before the rendering)
    // when the component flickers the animation process is ruined, hence we need to clear the store.

  }, {
    key: "requestClearStore",
    value: function requestClearStore() {
      var _this = this;

      this._clearSnapshotAnimationFrame = requestAnimationFrame(function () {
        return delete stores[_this._key];
      });
    }
  }, {
    key: "cancelClearStore",
    value: function cancelClearStore() {
      if (this._clearSnapshotAnimationFrame) {
        cancelAnimationFrame(this._clearSnapshotAnimationFrame);
      }
    }
  }, {
    key: "priorities",
    get: function get() {
      return this.components.map(function (_ref) {
        var singularPriority = _ref.props.singularPriority;
        return singularPriority;
      });
    }
  }]);

  return SingularComponentStore;
}();

exports.SingularComponentStore = SingularComponentStore;
var _default = SingularComponentStore;
exports["default"] = _default;